import { Box } from '@mui/material';
import { RotorElement } from '../../generalComponents/rotorElement/RotorElement';
import { PumpScadaIcon } from 'src/assets/icons/SCADA/assetsComponents/PumpScadaIcon';

type Props = {
  width?: number;
  height?: number;
  isAlarmActive: boolean;
  isRunMode: boolean;
};

export const RegularPump = ({ width, height, isAlarmActive, isRunMode }: Props) => {
  const widthOfElement = width ?? 180;
  const heightOfElement = height ?? 380;

  const lighRedColor = '#ffdad9';

  let testId = 'offState';

  if (isAlarmActive) {
    testId = `activeAlarm-${isRunMode ? 'onState' : 'offState'}`;
  } else if (isRunMode && !isAlarmActive) {
    testId = 'onState';
  }

  return (
    <Box position="relative" width="fit-content" height="fit-content" data-sm={testId}>
      <PumpScadaIcon
        width={widthOfElement}
        height={heightOfElement}
        fill={isAlarmActive ? lighRedColor : '#8C969B'}
      />
      <Box sx={{ position: 'absolute', left: '13%', bottom: '25%' }}>
        <RotorElement
          width={widthOfElement * 0.3}
          height={heightOfElement * 0.3}
          isAlarmActive={isAlarmActive}
          isRunMode={isRunMode}
        />
      </Box>
    </Box>
  );
};
